module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“Those who cannot remember the past are condemned to repeat it.”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-right-space-after"
  }, [_vm._v("—George Santayana")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-right-space-after"
  }), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“That men do not learn very much from the lessons of history is the most important of all the lessons of history.”")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-right-space-after"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("—Aldous Huxley")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d035fdde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KnifeRiver_5P2.vue
// module id = 75
// module chunks = 0